var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecycleBin(_ref, svgRef) {
  var _ref2;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 5.49945L19.75 11.4995M5.25 5.49945L5.855 15.5365C6.009 18.1065 6.087 19.3915 6.729 20.3165C7.046 20.7731 7.45469 21.1586 7.929 21.4485C8.511 21.8045 9.213 21.9445 10.25 21.9995M11.75 15.4995L12.886 16.9655C13.0923 16.1952 13.5242 15.5042 14.1261 14.9812C14.728 14.4582 15.4725 14.127 16.264 14.0301C17.0555 13.9333 17.8579 14.0752 18.5681 14.4377C19.2783 14.8002 19.864 15.3667 20.25 16.0645M21.75 20.4995L20.614 19.0354C20.4093 19.7997 19.9826 20.4861 19.3878 21.0078C18.793 21.5295 18.0568 21.8631 17.2724 21.9664C16.488 22.0697 15.6906 21.938 14.981 21.5881C14.2714 21.2381 13.6816 20.6856 13.286 20.0005M3.75 5.49945H21.75M16.806 5.49945L16.123 4.09145C15.67 3.15545 15.443 2.68845 15.052 2.39645C14.9651 2.33177 14.8732 2.27424 14.777 2.22445C14.344 1.99945 13.824 1.99945 12.785 1.99945C11.719 1.99945 11.186 1.99945 10.745 2.23345C10.6475 2.28566 10.5545 2.34587 10.467 2.41345C10.072 2.71645 9.851 3.20145 9.409 4.17045L8.803 5.49945",
    stroke: "#205A46",
    style: (_ref2 = {
      stroke: "#205A46"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1255 0.3529 0.2745)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBin);
export default __webpack_public_path__ + "static/media/recycleBin.d2ebb4f9.svg";
export { ForwardRef as ReactComponent };